import React, { useEffect, useState } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import RadioButton from '@components/RadioButton/RadioButton';

interface StyledProps {
  theme?: ITheme;
  margin: string | number;
  isTouched?: boolean;
  offsetLeft?: number | undefined;
  marginTablet: string | number;
}

interface HoverProps {
  theme?: ITheme;
  isTouched?: boolean;
  offsetLeft?: number;
}

const Container = styled.div<StyledProps>`
  border-radius: 5px;
  box-shadow: 0 2px 2px 0 rgba(204, 204, 204, 0.5);
  border: solid 1px ${props => props.theme?.colors.grey[100]};
  background-color: ${props => props.theme?.colors.grey[200]};
  position: relative;
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  @media screen and (min-width: 768px) {
    margin: ${props => typeof props.marginTablet === 'number' ? `${props.marginTablet}px` : props.marginTablet};
  }
`;

const HoverContainer = styled.div<HoverProps>`
  border-radius: 3px;
  background-color: ${props => props.theme?.colors.secondary || ''};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 50%;
  z-index: 1;
  display: ${props => props.isTouched ? 'block' : 'none'};
  transform: translateX(${props => props.offsetLeft === 0 ? '0' : '100%'});
  transition: transform .15s linear;
`;

const customRadioItem = css`
  display: inline-block;
  width: 50%;
`;

const removeDash = css`
  &:nth-child(odd) {
    &:after{
      visibility: hidden !important;
    }
  }
`

export interface RadioButtonGroupProps {
  value: string | number | null ;
  theme?: ITheme;
  children?: React.ReactNode;
  margin: string | number;
  marginTablet: string | number;
  onChange?: (e: any) => void;
  name?: string;
  className?: string;
}

function RadioButtonGroup({ children, value, margin, onChange, name, className, marginTablet }: RadioButtonGroupProps) {
  const theme = useTheme();
  const [selected, setSelected] = useState<string | number | null>(value);
  const [offsetLeft, setOffsetLeft] = useState<number | undefined>(0);
  const isTouched: boolean = value !== null && value !== '' && value !== undefined;
  const [touched, setTouched] = useState<boolean>(isTouched);
  const onChangeRadio = (event: any) => { 
    const value = event.target.value;
    setSelected(value);
    setTouched(true);
    if(onChange) {
      onChange(event);
      //console.log(event);
      //console.log(event.currentTarget.offsetLeft);
      setOffsetLeft(event.currentTarget.offsetLeft);
    }
  };
  useEffect(() => {
    const item1: any = React.Children.toArray(children)[0];
    const item2: any = React.Children.toArray(children)[1];
    const hasSelected = item1.props.value === value || item2.props.value === value;
    // console.log(hasSelected);
    if (hasSelected) {
      setOffsetLeft(item1.props.value === value ? 0 : 10);
    }
  },[setOffsetLeft, children, value]);
  
  const classes = touched ? customRadioItem + ' ' + removeDash : customRadioItem;

  return <Container theme={theme} margin={margin} marginTablet={marginTablet} className={className}>
    {React.Children.toArray(children).map((item: any, index: number) => {
      return (item.type === RadioButton && (
        <RadioButton
          name={name}
          trackedByGroup={true}
          key={`aiva-${index}-radio`}
          text={item.props.text}
          value={item.props.value}
          selected={selected}
          onChange={onChangeRadio}
          className={`radio-item ${classes}`}
        />
      ))
    })}
    <HoverContainer theme={theme} isTouched={isTouched} offsetLeft={offsetLeft} className={`radio-hover o${(offsetLeft) ? '0' : '100'}`}></HoverContainer>
  </Container>;
};

RadioButtonGroup.defaultProps = {
  margin: "0 0 30px",
  marginTablet: "0 0 30px",
}

export default RadioButtonGroup;
